export default {
  loading: 'Загрузка...',
  emptyState: 'Нет объектов',
  emptyStateAndFilterActive: 'Объекты, соответствующие выбранным фильтрам, не найдены'
}
